var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanFallback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 154,
    viewBox: "0 0 118 154",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 154,
    rx: 20,
    fill: "url(#paint0_linear_569_11064)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6879 111.314C32.2685 118.895 44.559 118.895 52.1395 111.314L59.001 104.453L65.8628 111.315C73.4433 118.895 85.7338 118.895 93.3143 111.315C100.895 103.734 100.895 91.4435 93.3143 83.8629L86.4526 77.0011L93.3169 70.1368C100.897 62.5563 100.897 50.2658 93.3169 42.6853C85.7363 35.1047 73.4458 35.1047 65.8653 42.6853L59.001 49.5496L52.137 42.6856C44.5564 35.105 32.2659 35.105 24.6854 42.6856C17.1049 50.2661 17.1049 62.5566 24.6854 70.1371L31.5494 77.0011L24.6879 83.8626C17.1074 91.4432 17.1074 103.734 24.6879 111.314Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_11064",
    x1: 0.344592,
    y1: 0.515457,
    x2: 147.18,
    y2: 117.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE597"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFallback);
export default __webpack_public_path__ + "static/media/PlanFallback.f33abfb45a01f89258e01835005e565f.svg";
export { ForwardRef as ReactComponent };